import { Box } from "@mui/material";

export const ExhaustedButton = () => {
  return (
    <Box 
      sx={{
        borderRadius: 5,
        color: "#808080",
        background: "#E5E4E2",
        width: "70px",
        textAlign: "center",
        padding: 0.3,
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        margin: "auto",
        fontSize: 12,
      }}
    >
      Exhausted
    </Box>
  );
};
